import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import {Box, Button, Card, CardActions, CardContent, CardMedia, Container, Grid, Link, Typography} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import projectData from '../../resources/projectData'

const useStyles = makeStyles(theme => ({
    container: {
        background: theme.palette.type === 'light' ? theme.palette.primary.light : theme.palette.background.default,
        padding: 0,
        // border: '2px solid orange',
    },
    headingContainer: {
        // border: '1px solid yellow',
        height: 150
    },
    cardContainer: {
        [theme.breakpoints.down('md')]: {
            width: '960px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '600px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '350px',
        },
        // border: '1px solid yellow',
        width: '1280px',
        marginTop: 30,
        marginBottom: 30,
        // paddingLeft: 20,
        // paddingRight: 20,
    },
    card: {
        height: 440,
        // width: 330,
        // marginBottom: 30,
        // border: '1px solid yellow',
    },
    cover: {
        height: 200,
        border: `4px solid ${theme.palette.primary.dark}`
    },
    detailsContainer: {
        // border: '1px solid red',
        height: 190,

    },
    techLabels: {
        //   border: '1px solid blue',
          marginTop: 10
    },
    cardAction: {
        // border: '1px solid blue',
    },
}))
const ProjectsPage = () => {

    const externalURL = (url) => {
        window.location.assign(url);
    }

    const classes = useStyles();
    return (
        <Container maxWidth="xl" className={classes.container}>
            <Grid container direction="column" alignItems="center">
            {/* heading */}
                <Grid item xs={12} md={6}>
                    <Grid container direction="column" justifyContent="center" alignItems="center" className={classes.headingContainer}>
                        <Grid item >
                            <Typography color="textPrimary" variant="h5" gutterBottom>
                                <b>My Noteworthy Projects</b>
                            </Typography>
                        </Grid>
                    <Grid item>
                        <ExpandMoreIcon color="primary"/>
                    </Grid>
                    </Grid>
                </Grid>

                    {/* cards */}
                    <Grid container direction="row" alignItems="center" spacing={4} className={classes.cardContainer}>
                        {projectData.map( project => (
                            <Grid item xs={12} sm={6} md={6} lg={4} key={project.title}>
                                <Card className={classes.card}>
                                    {/* image */}
                                    <CardMedia
                                        className={classes.cover}
                                        image={project.image}
                                        title={project.title}
                                    />
                                    <Grid item className={classes.detailsContainer}>
                                        <CardContent className={classes.content}>
                                            <Typography color="textPrimary" variant="subtitle1" align="left">
                                                {project.title}
                                            </Typography>
                                            <Typography  variant="subtitle1" color="textSecondary" align="left">
                                                {project.description}
                                            </Typography>
                                            <Grid container spacing={1} direction="row" className={classes.techLabels}>
                                                {project.label.map(item => (
                                                    <Grid item key={item}>
                                                        <Typography variant="subtitle2" align="left">
                                                            {item}
                                                        </Typography>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </CardContent>
                                    </Grid>
                                    {/* gitbuh repo */}
                                    <CardActions className={classes.cardAction}>
                                        <Grid container justifyContent="flex-end">
                                            <Link href='#' onClick={() => externalURL(project.url)}>
                                                <Typography  variant="subtitle1" color="primary" align="right">
                                                    github repo
                                                </Typography>
                                            </Link>
                                        </Grid>
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))}
                    </Grid> 
            </Grid>    
        </Container>
    )
}

export default ProjectsPage
